export const RewardedActivityEvents = Object.freeze({
    INVITE_FRIEND: { name: "invite a friend", translationKey: "inviteFriend", imageSrc: "/img/customer_magnet.png"},
    WRITE_REVIEW: { name: "write a review", translationKey: "writeReview", imageSrc: "/img/google-maps-reviews.png" },
    TIME_RULE: { name: "time rule", translationKey: "timeRule",  imageSrc: "/img/empty_gym.png" },
    ACTIVITY_FINISHED: { name: "activity finished", translationKey: "activityFinished",  imageSrc: "/img/crowded_gym.png"}
});

const eventNameMapping = {
    "invite a friend": RewardedActivityEvents.INVITE_FRIEND,
    "write a review": RewardedActivityEvents.WRITE_REVIEW,
    "time rule": RewardedActivityEvents.TIME_RULE,
    "activity finished": RewardedActivityEvents.ACTIVITY_FINISHED
};

export function mapRewardedActivityEvent(eventName) {
    return Object.prototype.hasOwnProperty.call(eventNameMapping, eventName)
        ? eventNameMapping[eventName]
        : null;
}

